import styled from "styled-components";
import * as common from "../../common";

export const loadingWrapper = styled(common.flexColumn)`
  height: 100vh;
`;
